import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Select, InputNumber } from "antd";
import { showConfirmDlgWidget } from 'components/ConfirmDlgWidget/showConfirmDlgWidget';
import DetailTable from './DetailTable';
import { getCurrencyInfo } from 'utils/GlobalFunctions';
const { Option } = Select;

function TableWidget(props) {
    const [isBusy, setIsBusy] = useState(false);
    const { dataList, setDataList, paymentConfirmAction } = props;
    if (dataList === undefined) return <div />

    const columns = [
        {
            title: "ID",
            dataIndex: "id",
        },
        {
            title: "Customer Name",
            dataIndex: "customer_name",
            align : "center",
            sorter: {
                compare: (a, b) => a.customer_name.localeCompare(b.customer_name),
            },
        },
        {
            title: "Email",
            dataIndex: "customer_email",
            align : "center",
            sorter: {
                compare: (a, b) => a.customer_email.localeCompare(b.customer_email),
            },
        },
        {
            title: "Table Name",
            dataIndex: "table_name",
            align : "center",
            sorter: {
                compare: (a, b) => a.table_name.localeCompare(b.table_name),
            },
        },
        {
            title: "Total budget",
            dataIndex: "totalBudget",
            align : "center",
            sorter: {
                compare: (a, b) => a.totalBudget - b.totalBudget,
            },
            render: text => <span>{ "$ " + parseFloat(text).toFixed(4)}</span>,
        },
        {
            title: "Currency",
            dataIndex: "payment_currency",
            align : "center",
            sorter: {
                compare: (a, b) => a.payment_currency.localeCompare(b.payment_currency),
            },
        },
        {
            title: "Pay GateWay",
            dataIndex: "pay_gateway",
            align : "center",
            sorter: {
                compare: (a, b) => a.pay_gateway.localeCompare(b.pay_gateway),
            },
        },
        {
            title: "Pay Status",
            dataIndex: "payment_status",
            align : "center",
            sorter: {
                compare: (a, b) => a.payment_status.localeCompare(b.payment_status),
            },
            render: (text, record) => {
                if (record.payment_status === null || record.payment_status === undefined || record.payment_status === '') {
                    return (
                        <div>--</div>
                    )
                }
                else {
                    return (
                        <div>{record.payment_status}</div>
                    )
                }
            },
        },
        {
            title: "Created Date",
            dataIndex: "add_timestamp",
            align : "center",
            sorter: {
                compare: (a, b) => a.add_timestamp.localeCompare(b.add_timestamp),
            },
        },
        {
            title: "Updated Date",
            dataIndex: "update_timestamp",
            align : "center",
            sorter: {
                compare: (a, b) => a.update_timestamp.localeCompare(b.update_timestamp),
            },
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            render: (text, record) => {
                if (record.payment_status === null || record.payment_status === undefined || record.payment_status === '') {
                    return (
                        <div size="middle" direction={"vertical"}>
                            <a className="del-btn"
                                style={{ color: "var(--redColor)", marginLeft: 20 }}
                                onClick={async () => {
                                    var res = await showConfirmDlgWidget({ title: "Payment Confirmation", content: "Payment is not completed, yet. Please check it and once it is finished, click 'Yes' button." });
                                    if (res == false) return;
                                    paymentConfirmAction(record)
                                }}
                            >
                                Pay Check
                            </a>
                            {/* <a style={{ color: "var(--redColor)", marginLeft: 20 }} className="del-btn" onClick={async () => {
                                var res = await showConfirmDlgWidget({ title: "Delete Confirmation", content: "Are you sure to delete this order?" });
                                if (res == false) return;
                                //                        onDeleteAction(record)
                            }}>
                                Delete
                            </a> */}
                        </div>
                    );
                }
                else {
                    return (
                        <div style={{ color: "var(--blueColor)", marginLeft: 20 }}>Finished</div>
                    )
                }
                
            },
        },
    ];
    const dataSource = dataList.map((info) => {
        return { ...info, key: info.id };
    });

    return (
        <div className="list-table">
            <Table
                pagination={false}
                columns={columns}
                dataSource={dataSource}
                expandedRowRender={record => {
                    return <DetailTable
                        dataList={record.cartList} />
                }}
            />
        </div>
    )
}

export default withRouter(TableWidget)
